
/**
 * native add ons all in one place
 * translate loader configuration also avaible here
 */
import { HttpClient } from '@angular/common/http';
import { CallNumber } from '@ionic-native/call-number/ngx';
import { Camera } from '@ionic-native/camera/ngx';
import { Facebook } from '@ionic-native/facebook/ngx';
import { FirebaseAuthentication } from '@ionic-native/firebase-authentication/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { GooglePlus } from '@ionic-native/google-plus/ngx';
import { ImagePicker } from '@ionic-native/image-picker/ngx';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export const NativeImports = [
  StatusBar,
  SplashScreen,
  FirebaseAuthentication,
  Camera,
  CallNumber,
  ImagePicker,
  Facebook,
  GooglePlus,
  Geolocation,
  SocialSharing
];

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
